import { useEffect, useRef } from 'react'
import {
  createSusiLightConfig,
  SusiLightElement,
  SusiLightWrapperProps
} from './SusiLight.config'

export const SusiLightWrapper = ({
  redirectUri,
  onSusiRedirect,
  onSusiToken,
  onSusiError,
  onSusiLoad
}: SusiLightWrapperProps) => {
  const susi = useRef<SusiLightElement>(null)

  useEffect(() => {
    const element = susi.current
    if (element) {
      Object.assign(element, createSusiLightConfig(redirectUri))
      element.addEventListener('redirect', onSusiRedirect as EventListener)
      element.addEventListener('on-token', onSusiToken as EventListener)
      element.addEventListener('on-error', onSusiError as EventListener)
      element.addEventListener('on-load', onSusiLoad as EventListener)
    }

    return () => {
      const element = susi.current
      if (element) {
        element.removeEventListener('redirect', onSusiRedirect as EventListener)
        element.removeEventListener('on-token', onSusiToken as EventListener)
        element.removeEventListener('on-error', onSusiError as EventListener)
        element.removeEventListener('on-load', onSusiLoad as EventListener)
      }
    }
  }, [susi, redirectUri])

  return (
    <susi-sentry-light
      ref={susi}
      type="standard"
      id="susi-sentry"
      variant="standard"
    />
  )
}
